import { createContext } from 'react';

import { DEFAULT_SUGGESTIONS_COUNT } from '../suggestions/suggestions-config.js';
import type { FilterFieldContextProps } from './FilterFieldContext.types.js';

/** @internal */
export const FilterFieldContext = createContext<FilterFieldContextProps>({
  applySuggestion: () => null,
  dispatch: () => null,
  autoSuggestions: {},
  flattenedSuggestionItems: [],
  groupMetadata: [],
  defaultSuggestionsCount: DEFAULT_SUGGESTIONS_COUNT,
  recentSuggestionValues: [],
  pinnedSuggestionValues: [],
  logicalOperatorSuggestionValues: [],
  pastedContentSuggestionValues: [],
  searchSuggestionValues: [],
  fallbackKeySuggestionValues: [],
  statementSuggestionValues: [],
  suggestionsOverlayRef: null,
  triggerRef: null,
  filterNamespace: null,
  editorView: null,
  handleNextSuggestion: () => null,
  filterFieldRootId: '',
});
